import { Link } from 'react-router-dom';
import { ChangelogButton } from './ChangelogModal';

export function PaizoFooter() {
  return (
    <footer className="border-t border-gray-800 bg-gray-900/80 px-4 sm:px-6 py-4">
      <div className="max-w-7xl mx-auto text-center text-xs text-gray-500 leading-relaxed space-y-2">
        <div className="flex items-center justify-center gap-3">
          <ChangelogButton />
          <span className="text-gray-700">|</span>
          <Link to="/legal" className="text-gray-400 underline hover:text-gray-300 transition-colors">
            Impressum
          </Link>
          <span className="text-gray-700">|</span>
          <Link to="/legal#datenschutz" className="text-gray-400 underline hover:text-gray-300 transition-colors">
            Datenschutz
          </Link>
          <span className="text-gray-700">|</span>
          <a
            href="https://paizo.com/licenses/communityuse"
            target="_blank"
            rel="noopener noreferrer"
            className="text-gray-400 underline hover:text-gray-300 transition-colors"
          >
            Paizo Community Use Policy
          </a>
        </div>
        <p>
          CharBuilder uses trademarks and/or copyrights owned by Paizo Inc., used under
          Paizo's Community Use Policy. We are expressly prohibited from charging you to use
          or access this content. CharBuilder is not published, endorsed, or specifically
          approved by Paizo. For more information about Paizo Inc. and Paizo products, visit{' '}
          <a
            href="https://paizo.com"
            target="_blank"
            rel="noopener noreferrer"
            className="text-gray-400 underline hover:text-gray-300 transition-colors"
          >
            paizo.com
          </a>
          .
        </p>
        <p className="text-gray-600">
          ©2002–2026 Paizo Inc.® All Rights Reserved. Pathfinder and Starfinder are trademarks of Paizo Inc.
        </p>
      </div>
    </footer>
  );
}
